export default class ClaimsService {
  constructor(claims) {
    this.refresh(claims);
  }

  refresh(claims) {
    claims = claims || [];

    let initialClaims = {
      admin: {
        read: false
      },
      dashboard: {
        read: false,
        financial: false,
      },
      items: {
        read: false,
        write: false,
      },
      vendors: {
        read: false,
        write: false
      },
      purchasesuggestions: {
        read: false,
        new: false,
        accounting: false,
        mayor: false,
        stadtamtsdirektor: false,
        bauhofleiter: false,
      },
      purchaseorders: {
        read: false,
        write: false,
        newshipment: false,
        newreceipt: false,
      },
      storagelocations: {
        read: false,
        write: false
      },
      stocktaking: {
        read: false,
        write: false
      },
      timepark: {
        read: false
      },
      syncservice: {
        sync: false
      },
      roles: {
        override: false
      }
    };

    for(let claim of claims) {
      if(claim.indexOf(':') === -1) {
        console.error('Received malformed claim: ' + claim);
        continue;
      }

      let [ resource, permission ] = claim.split(':');

      if(initialClaims[resource] === undefined) {
        console.error('Received unknown claim resource: ' + resource + ' of ' + claim);
        continue;
      }

      if(initialClaims[resource][permission] === undefined) {
        console.error('Received unknown claim permission: ' + permission + ' of ' + claim);
        return false;
      }

      initialClaims[resource][permission] = true;
    }

    this.claims = initialClaims;
  }

  hasClaim(claim) {
    if(claim.indexOf(':') === -1) {
      console.error('Malformed claim: ' + claim);
      return false;
    }

    let [ resource, permission ] = claim.split(':');

    if(this.claims[resource] === undefined) {
      console.error('Unknown claim resource: ' + resource + ' of ' + claim);
      return false;
    }

    let claimValue = this.claims[resource][permission];

    if(claimValue === undefined) {
      console.error('Unknown claim permission: ' + permission + ' of ' + claim);
      return false;
    }

    return claimValue;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ClaimsService.js